import SubHeader from "@/components/SubHeader";
import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.ProjectIntroSlice} ProjectIntroSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ProjectIntroSlice>} ProjectIntroProps
 * @type {import("react").FC<ProjectIntroProps>}
 */
const ProjectText = ({ slice }) => {
  const { variation } = slice;
  const { sub_header, title, text } = slice.primary;
  const sub_title = variation === "default" ? slice.primary.sub_title : undefined;

  return <section
    data-slice-type={slice.slice_type}
    data-slice-variation={slice.variation}>
    <div className={`framing w-full flex flex-col gap-10`}>
      <div className="flex flex-col gap-7">
        <div className="flex flex-col gap-3 w-full md:w-2/3">
          {isFilled.keyText(sub_header) && <SubHeader text={sub_header} />}
          {
            isFilled.richText(title) && variation === "default" ?
              <PrismicRichText
                field={title}
                components={{
                  heading1: ({ children }) => (
                    <h1 className="project-title-n text-bleu">{children}</h1>
                  ),
                  heading2: ({ children }) => (
                    <h2 className="project-title-n text-bleu">{children}</h2>
                  ),
                }}
              /> : <PrismicRichText
                field={title}
                components={{
                  heading1: ({ children }) => (
                    <h1 className="h2-n lg:dk bd text-bleu">{children}</h1>
                  ),
                  heading2: ({ children }) => (
                    <h2 className="h2-n lg:dk bd text-bleu">{children}</h2>
                  ),
                  heading3: ({ children }) => (
                    <h3 className="h2-n lg:dk bd text-bleu">{children}</h3>
                  )
                }}
              />
          }
        </div>

        {isFilled.richText(sub_title) && (
          <PrismicRichText
            field={sub_title}
            components={{
              heading2: ({ children }) => (
                <h2 className="h2-n lg:dk bd text-bleu">{children}</h2>
              ),
              heading3: ({ children }) => (
                <h3 className="h2-n lg:dk bd text-bleu">{children}</h3>
              ),
              heading4: ({ children }) => (
                <h4 className="h2-n lg:dk bd text-bleu">{children}</h4>
              )
            }}
          />
        )}
      </div>

      {isFilled.richText(text) && (
        <div className="flex flex-col gap-4">
          <PrismicRichText field={text} components={{
            paragraph: ({ children }) => (
              <p className="p-lg-n md:p-xl-n md:lt text-bleu">{children}</p>
            ),
          }} />
        </div>
      )}
    </div>
  </section >
};

export default ProjectText;
